module.exports = __webpack_public_path__ + "wpicons.4f5379fe5e5f551841dc.woff";


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/assets/fonts/wpicons.woff
// module id = ../../../../../src/assets/fonts/wpicons.woff
// module chunks = 2